import React, {Fragment, memo, useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import _cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';

import {
    Checkbox,
    Message,
    Pagination,
    ShowItemsSelectPageCount,
    OverestimationModal,
    ToFormRegisterModal,
    ToFormWithdrawalInventoryModal,
} from '../../utilites';
import {
    pageOptions,
    contractStatuses,
    viewDocument,
    viewReports,
    listRoles
} from '../../../helpers/data-constants';
import {
    changeContractStatuses,
    transferDeals,
    overestimationDeals,
    getDealToRetention,
    getDealToRetentionFailed, setSelectedItems, resetSelectedItems, getClientContracts, clearContractError,
} from '../../../redux/actions/contractAction';
import { getDepartments, getDepartmentsSuccess } from "../../../redux/actions/handbookAction";
import {
    returnEndStr,
    containsNotActiveNotProlong,
    useQuery,
    permissionsAccess,
    calculationAccess, validateDelayDays
} from '../../../helpers/common';
import {ActionButton, AlertModal, ConfirmModal} from '../../common';
import OverdueDetails from './OverdueDetails/OverdueDetails';
import Loader from '../Loader/Loader';
import ClientDropdown from '../../../components/utilites/CustomDropdown/DropdownClient/ClientDropdown';

import './overdueContentAll.scss';

import Arrow from '../../../assets/icons/arrow-down.svg';

const initialState = {
    showModalEnterDate: false,
    currentPage: 1,
    pageRange: pageOptions[0].value,
    isToTransfer: false,
    isRegister: false,
    isTN: false,
    isOverestimation: false,
    isWithdrawal: false,
    isToGarage: false,
    viewDocument: '',
    dealIds: [],
    permissibleDate: 0,
    isShow: {
        redemptionDate: false,
    },
};

const containsThing = (arr) => {
    let result = true;
    for (const deal of arr) {
        if (deal.type !== 'THINGS') {
            result = false;
            break;
        }
    }
    return result;
};

const containsPurity = (arr) => {
    let result = true;
    for (const deal of arr) {
        if (deal.type !== 'PURITY') {
            result = false;
            break;
        }
    }
    return result;
};

const containsDelayDays = (arr, isExtensionThreeImplementaition) => {
    let result = true;
    for (const deal of arr) {
      const days = isExtensionThreeImplementaition ? deal.delayDays : deal.graceDays;
        if (days < 31) {
            result = false;
            break;
        }
    }
    return result;
};

const fields = ["revaluationDays",'amount', 'basePercent', 'cashBox', 'cashBoxId', 'clientFullName', 'clientId', 'couponName', 'dealNumber', 'delayDays', 'delayPercent', 'endDate', 'id', 'refundAmount', 'startDate', 'status',
  'totalEstimatedValue', 'totalToPay', 'type', 'positions', 'position.positionId', 'positions.names', 'positions.model', 'positions.quantity', 'positions.estimatedValue', 'positions.imei', 'positions.pureWeight', 'positions.grossWeight',
  'positions.comment', 'positions.purityType', 'positions.purityName', 'waiverOfRedemption', 'graceDays']

const OverdueContentAll = memo(({
                                    dealStatus,
                                    cashBoxInfo,
                                    searchFacets,
                                    setError,
                                    searchState
                                }) => {
    const {cashBoxIds, fullName, dealNumber, typeDeal, delaysDay, typeDuration} = searchState;
    const {
        clientContracts: {deal, total},
        isLoading,
        commonError,
        changeContract,
        clientContract,
        selectedItems
    } = useSelector(({contract}) => contract);
    const {accessFeatures} = useSelector(({user}) => user);
    const dispatch = useDispatch();
    const [state, setState] = useState(initialState);
    const branchDirector = calculationAccess([listRoles.BRANCH_DIRECTOR])
    const [overdueContracts, setOverdueContracts] = useState([]);
    const [selectedDeals, setSelectedDeals] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [popup, setPopup] = useState({
        isOpen: false,
        header: 'Ошибка',
        text: '',
    });

    const history = useHistory()
    const query = useQuery()
    const queryPageRange = query.get('pageRange')
    const queryPage = query.get("page");
    const queryStatus = query.get('dealStatus')
    const isInternalMovement = accessFeatures['internal.movement.delivery.invoice']
    const isExtensionThreeImplementaition = accessFeatures["extension.implementation.type.three"]

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            currentPage: 1,
        }))
    }, [cashBoxIds, dealNumber, typeDeal, fullName, searchFacets, delaysDay, typeDuration])

    useEffect(() => {
        return () => {
            setState((prev) => ({
                ...prev,
                currentPage: 1,
                pageRange: pageOptions[0].value,
            }));
            dispatch(clearContractError())
        };
    }, [dealStatus, dispatch]);

    useEffect(() => {
        if (queryStatus === dealStatus) {
            let actualPageRange = state.pageRange
            let actualPage = state.currentPage

            if (!!queryPageRange) actualPageRange = +queryPageRange
            if (!!queryPage) actualPage = +queryPage

            setState((prev) => ({
                ...prev,
                currentPage: actualPage,
                pageRange: actualPageRange,
            }))
        }
    }, [])

    useEffect(() => {
        history.push({
            search: `?dealStatus=${dealStatus}&pageRange=${state.pageRange}&page=${state.currentPage}`
        })
    }, [dealStatus, state.pageRange, state.currentPage])

    useEffect(() => {
        const formattedDeals = deal.map((i) => {
            i.checked = selectedItems.has(i.id);
            i.isVisible = false;
            return i;
        });
        setOverdueContracts(formattedDeals);
    }, [deal]);

    useEffect(() => {
        setSelectedDeals(Array.from(selectedItems.values()));
    }, [selectedItems.size]);

    useEffect(() => {
        setAllChecked(false);
    }, [cashBoxIds, searchFacets]);

    useEffect(() => {
        setAllChecked(false)
        let dealType = '';

        if (
            searchFacets.filter((i, ind) => {
                if (ind !== searchFacets.length - 1) {
                    return i.active;
                }
            }).length
        ) {
            dealType = searchFacets.find(({active}) => active).id;
        }

        const validationResult = validateDelayDays(delaysDay);

        if (validationResult) {
            setError(validationResult);
            return;
        } else {
            setError('')
        }

        const clientContractsPayload = {
            size: state.pageRange,
            page: state.currentPage,
            status: dealStatus === 'EXPIRED' ? 'EXPIRED,EXPIRED_PAYMENT' : dealStatus,
            id: 'all',
            descending: true,
            sortBy: isExtensionThreeImplementaition ? 'delayDays' : 'graceDays',
            dealType: dealType,
            clientIds: fullName.map(i => i.value).join(','),
            dealIds: dealNumber.map(i => i.value).join(','),
            dealTypes: typeDeal.map(i => i.value).join(','),
            dealDuration: typeDuration.map(i => i.value).join(','),
            fields: fields,
            delayFrom: isExtensionThreeImplementaition ? delaysDay.from : undefined,
            delayTo: isExtensionThreeImplementaition ? delaysDay.to : undefined,
            graceFrom: isExtensionThreeImplementaition ? undefined : delaysDay.from,
            graceTo: isExtensionThreeImplementaition ? undefined : delaysDay.to
        };
        
        if (branchDirector && cashBoxIds.length === 0) {
          const availableDepartaments = JSON.parse(localStorage.getItem('AVAILABLE_DEPARTMENTS'))

            dispatch(getClientContracts({
                ...clientContractsPayload,
                cashBoxIds: availableDepartaments.join(','),
            }))
        } else {
            dispatch(getClientContracts({
                ...clientContractsPayload,
                cashBoxIds: cashBoxIds.map((i) => i.value).join(','),
            }))
        }
    }, [
        state.pageRange,
        state.currentPage,
        dispatch,
        changeContract,
        dealStatus,
        cashBoxIds,
        searchFacets,
        clientContract,
        fullName,
        dealNumber,
        typeDeal,
        typeDuration,
        delaysDay
    ]);

    const onPageRangeChange = useCallback((value) => {
        setState((prev) => ({
            ...prev,
            pageRange: parseInt(value),
            currentPage: 1,
        }));
        setAllChecked(false);
    }, []);

    const handlePageChange = useCallback((page) => {
        setState((prev) => ({
            ...prev,
            currentPage: page,
        }));
        setAllChecked(false);
    }, []);

    const handleAllContractCheck = useCallback(() => {
        setOverdueContracts((prev) => prev.map((item) => ({...item, checked: !allChecked})));
        overdueContracts.forEach(item => {
            if (!allChecked) {
                selectedItems.set(item.id, item);
            } else {
                selectedItems.delete(item.id);
            }
        })
        dispatch(setSelectedItems(selectedItems))
        setAllChecked(!allChecked);
    }, [allChecked, overdueContracts, selectedItems]);

    const handleContractCheck = useCallback(
        (e) => {
            let id = overdueContracts.findIndex((item) => item.id === +e.target.id);
            let newArray = _cloneDeep(overdueContracts);
            newArray[id].checked = !overdueContracts[id].checked;
            newArray.forEach(item => {
                if (item.checked) {
                    selectedItems.set(item.id, item);
                } else {
                    selectedItems.delete(item.id);
                }
            })
            dispatch(clearContractError())
            dispatch(setSelectedItems(selectedItems))
            setOverdueContracts(newArray);
        },
        [overdueContracts],
    );

    const changeVisible = (id) => {
        let ind = overdueContracts.findIndex((item) => item.id === id);
        let newArray = _cloneDeep(overdueContracts);
        newArray[ind].isVisible = !overdueContracts[ind].isVisible;
        setOverdueContracts(newArray);
    };

    const openModal = useCallback(
        (view) => {
            if (view === viewDocument.isToTransfer) {
                if (containsNotActiveNotProlong(selectedDeals)) {
                    setPopup((prev) => ({
                        ...prev,
                        isOpen: true,
                        text: 'Выбранный список содержит неактивные договора',
                    }));
                    return;
                }

                if (selectedDeals.length)
                    setState((prev) => ({...prev, [view]: true, dealIds: selectedDeals.map((i) => i.id)}));
            }

            if (view === viewDocument.isRegister) {
                if (!containsPurity(selectedDeals) || !containsDelayDays(selectedDeals, isExtensionThreeImplementaition)) {
                    setPopup((prev) => ({
                        ...prev,
                        isOpen: true,
                        text: 'Выбранный список содержит неподходящие договора',
                    }));
                    return;
                }

                if (selectedDeals.length) {
                    setState((prev) => ({
                        ...prev,
                        [view]: true,
                        viewDocument: viewDocument.isRegister,
                        dealIds: selectedDeals.map((i) => i.id),
                        permissibleDate: selectedDeals.reduce(
                            (p, c) => (p <= c.delayDays - 31 ? p : c.delayDays - 31),
                            selectedDeals[0].delayDays,
                        ),
                    }));
                }
            }

            if (view === viewDocument.isTN) {
                if (!containsThing(selectedDeals) || !containsDelayDays(selectedDeals, isExtensionThreeImplementaition)) {
                    setPopup((prev) => ({
                        ...prev,
                        isOpen: true,
                        text: 'Выбранный список содержит неподходящие договора',
                    }));
                    return;
                }

                if (selectedDeals.length) {
                    setState((prev) => ({
                        ...prev,
                        [view]: true,
                        viewDocument: viewDocument.isTN,
                        dealIds: selectedDeals.map((i) => i.id),
                        permissibleDate: selectedDeals.reduce(
                            (p, c) => (p <= c.delayDays - 31 ? p : c.delayDays - 31),
                            selectedDeals[0].delayDays,
                        ),
                    }));
                }
            }

            if (view === viewDocument.isOverestimation) {
                if (!containsThing(selectedDeals)) {
                    setPopup((prev) => ({
                        ...prev,
                        isOpen: true,
                        text: 'Выбранный список содержит неподходящие договора',
                    }));
                    return;
                }

                if (selectedDeals.length) {
                    setState((prev) => ({
                        ...prev,
                        [view]: true,
                    }));
                }
            }

            if (view === viewDocument.isWithdrawal) {
                if (selectedDeals.length) {
                    setState((prev) => ({
                        ...prev,
                        [view]: true,
                        viewDocument: viewDocument.isWithdrawal,
                        dealIds: selectedDeals.map((i) => i.id),
                    }));
                }
            }
        },
        [selectedDeals],
    );

    const handleCloseModal = useCallback((view) => {
        setState((prev) => ({...prev, [view]: false, viewDocument: ''}));
        dispatch(getDepartmentsSuccess([]))
        dispatch(getDepartments('', false, true));
    }, []);

    const addToTransfer = useCallback(() => {
        handleCloseModal(viewDocument.isToTransfer);
        if (overdueContracts.length === state.dealIds.length && state.currentPage > 1) {
            setState((prev) => ({...prev, currentPage: prev.currentPage - 1}));
        } else {
            setState((prev) => ({...prev, currentPage: 1}));
        }

        dispatch(changeContractStatuses(state.dealIds, contractStatuses.TOTRANSFER.param));
        setAllChecked(false);
        dispatch(resetSelectedItems())
    }, [handleCloseModal, dispatch, state.currentPage, overdueContracts.length, state.dealIds]);

    const closeAlertModal = useCallback(() => {
        setPopup((prev) => ({...prev, isOpen: false, text: ''}));
    }, []);

    const closeConfirm = useCallback(
        () => handleCloseModal(viewDocument.isToTransfer),
        [handleCloseModal],
    );

    const submitTransferDeals = useCallback(
        (data, name = false, identity = false) => {
          const { documentNumber, transferDate, reqData, internalMovementData } = data;

          const filename = 'exp_' + documentNumber + '_' + transferDate + '.pdf';
          let viewReport;
          if (overdueContracts.length === state.dealIds.length && state.currentPage > 1) {
            setState((prev) => ({...prev, currentPage: prev.currentPage - 1}));
          } else {
            setState((prev) => ({...prev, currentPage: 1}));
          }
          
          if (state.isTN) viewReport = viewReports.INTERNAL_MOVEMENT_STORE;
          if (state.isRegister) viewReport = viewReports.INTERNAL_MOVEMENT_GOHRAN;
          if (state.isWithdrawal) viewReport = viewReports.WITHDRAWAL;
          
          if (isInternalMovement && state.isRegister) {
            const filenameInternal = 'exp_' + reqData.documentNumber + '_' + reqData.transferDate + '.xlsx';
            dispatch(transferDeals({
              reqData, internalMovementData}, 
              {viewReport, viewInternalReport: viewReports.INTERNAL_MOVEMENT_GOHRAN_PL}, 
              {pdf: filename, xlsx: filenameInternal}, name, identity));
            return
          }
          dispatch(transferDeals(data, viewReport, {pdf: filename}, name, identity));
          setAllChecked(false);
          dispatch(resetSelectedItems());
        },
        [
            dispatch,
            state.currentPage,
            overdueContracts.length,
            state.dealIds,
            state.isTN,
            state.isRegister,
            state.isWithdrawal,
        ],
    );

    const submitOverestimation = (data) => {
        const convertedData = {
            dealsIds: data.dealsIds.map(({dealId, estimatedValue}) => ({
                dealId,
                estimatedValue,
            })),
            base: data?.base ? data.base : '',
        };

        if (overdueContracts.length === data.dealsIds.length && state.currentPage > 1) {
            setState((prev) => ({...prev, currentPage: prev.currentPage - 1}));
        } else {
            setState((prev) => ({...prev, currentPage: 1}));
        }
        
        const dealIds = convertedData.dealsIds.map(({ dealId }) => dealId).join(',');
        const filename =
          'exp_' +
          (convertedData.documentNumber ? convertedData.documentNumber : dealIds) +
          '_' +
          moment().format('DD.MM.YYYY') +
          '_.pdf';

        const bodyReport = {
          reqBodyReport: {
            cashBoxId: cashBoxInfo.id,
            dealIds,
            documentNumber: data?.documentNumber ? data.documentNumber : 'б/н'
          },
          filename,
          viewReport: viewReports.REVALUATION_ACT,
        };

        if(isInternalMovement) {
          dispatch(overestimationDeals(convertedData, bodyReport, true));
        } else {
          dispatch(overestimationDeals(convertedData));
        }

        setAllChecked(false);
        dispatch(resetSelectedItems())
        handleCloseModal(viewDocument.isOverestimation);
    };

  const returnToProcessing = () => {
    if (selectedDeals.length) {
      const dealsWithWaiverOfRedemption = selectedDeals.map(({waiverOfRedemption})=>waiverOfRedemption).includes(true)

      if (dealsWithWaiverOfRedemption &&
          !permissionsAccess('action.deal.status.transfer.waiver_of_redemption')) {
        setPopup((prev) => ({
          ...prev,
          isOpen: true,
          text: 'Договор c функцией “отказ от выкупа” может вернуть в обработку только директор',
        }));
      }
      else {
        if (overdueContracts.length === selectedDeals.length && state.currentPage > 1) {
          setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
        } else {
          setState((prev) => ({ ...prev, currentPage: 1 }));
        }
        const dealIds = selectedDeals.map(({ id }) => id);
        dispatch(
          changeContractStatuses(
            dealIds,
            contractStatuses.ACTIVE.param,
            null,
            contractStatuses.TOTRANSFER.param,
          ),
        );
        setAllChecked(false);
        dispatch(resetSelectedItems())
      }
    }
  };

    const viewDropdown = {
        redemptionDate: 'redemptionDate',
    };

    const handleAddRedemptionDate = useCallback((data) => {
        const retentionData = {
            id: selectedDeals[0]?.id,
            date: data?.redemptionDate,
        };

        if (!data.redemptionDate) {
            dispatch(getDealToRetentionFailed('Обещанная дата выкупа не выбрана'));
        } else if (data.redemptionDate && selectedDeals.length === 1) {
            if (overdueContracts.length === selectedDeals.length && state.currentPage > 1) {
                setState((prev) => ({...prev, currentPage: prev.currentPage - 1}));
            }

            dispatch(getDealToRetention(retentionData));
            dispatch(resetSelectedItems())
        } else if (data.redemptionDate && selectedDeals.length > 1) {
            dispatch(getDealToRetentionFailed('Для передачи на удержание необходимо выбрать не более одного договора'));
        }
    }, [dispatch, selectedDeals]);

    const changeIsShow = useCallback(
        (view) => {
            setState((prev) => ({
                ...prev,
                isShow: {
                    ...state.isShow,
                    [view]: !state.isShow[view],
                },
            }));
        },
        [state.isShow],
    );

    const handleShow = useCallback(
      (view) => {
         if (selectedDeals.length) {
          changeIsShow(view)
         } else {
          dispatch(getDealToRetentionFailed('Договор для передачи на удержание не выбран'));
         }
      },
      [selectedDeals, changeIsShow, dispatch],
  );

    const date = moment().format('YYYY-MM-DD');

  const clearCountContract = () => {
    dispatch(resetSelectedItems())
    setSelectedDeals([])
    setOverdueContracts(prevState => prevState.map(item => ({...item, checked: false})))
    setAllChecked(false)
  }
  
  return (
    <>
      {commonError && <Message type="error" text={commonError} />}
      <div className="content-datatable">
        <div className="content-datatable-header sticky">
          <div className="content-datatable-header-left  buttongroup-content">
            <div className="action-items action-items__inline">
              {
                permissionsAccess("action.deal.redemption.date") && dealStatus === contractStatuses.EXPIRED.param && (
                <ClientDropdown
                  text="Обещанная дата выкупа"
                  handleChangeContract={handleAddRedemptionDate}
                  content={'redemptionDate'}
                  initValues={{ redemptionDate: date }}
                  isShow={state.isShow}
                  changeIsShow={handleShow}
                  viewDropdown={viewDropdown}
                  selectedDeals={selectedDeals}>
                  <span className="action-dropdown">Обещанная дата выкупа</span>
                </ClientDropdown>
              )}
              {
                permissionsAccess("action.deal.status.transfer.expired") && dealStatus === contractStatuses.EXPIRED.param && (
                <ActionButton
                    text={accessFeatures['cars.feature']
                        ? "На передачу / в гараж"
                        : "На передачу"}
                  func={openModal}
                  param={viewDocument.isToTransfer}
                />
              )}
              {dealStatus === contractStatuses.TOTRANSFER.param && (
                <>
                  {
                    permissionsAccess("action.deal.transfer") &&
                      <ActionButton
                        text="Сформировать товарную накладную"
                        func={openModal}
                        param={viewDocument.isTN}
                      />
                      }
                      {
                        permissionsAccess("action.deal.transfer.gohran") &&
                        <ActionButton
                            text="Сформировать опись"
                            func={openModal}
                            param={viewDocument.isRegister}
                        />
                      }
                    <>
                      {
                        permissionsAccess("action.deal.update.thing.estimated.value") &&
                        <ActionButton
                            text="Переоценка"
                            func={openModal}
                            param={viewDocument.isOverestimation}
                        />
                      }
                      {
                        permissionsAccess("action.deal.transfer.withdrawal") &&
                        <ActionButton
                            text="Сформировать изъятие"
                            func={openModal}
                            param={viewDocument.isWithdrawal}
                        />
                      }
                    </>
                  {
                    permissionsAccess("action.deal.status.transfer.active") &&
                    <ActionButton text="Вернуть в обработку" func={returnToProcessing} />
                  }
                </>
              )}
            </div>
          </div>
          <div className="content-datatable-header-right overdueContentAll-right">
            <ShowItemsSelectPageCount
              options={pageOptions}
              change={onPageRangeChange}
              wrapClass={'padding-select'}
              statePageRange={state.pageRange}
            />
          </div>
        </div>
        <div className="content-datatable-content">
          {isLoading ? (
            <Loader pageRange={state.pageRange} />
          ) : (
            <table className="table hover">
              <thead>
                <tr>
                  <th scope="col">
                    <Checkbox
                      label="Номер договора"
                      id="checkboxContractSelectAll"
                      name="checkboxContractSelectAll"
                      onChange={handleAllContractCheck}
                      value={allChecked}
                    />
                    <button className={'action-item m-t-spacer'} onClick={clearCountContract}>
                      <p className={'m-b-0'}>{'количество выбранных договоров:'}</p>
                      <span className={'font-size-max m-l-spacer'}>{`${selectedItems.size || 0}`}</span>
                    </button>
                  </th>
                  <th scope="col">
                    <p>Клиент</p>
                  </th>
                  <th scope="col">
                    <p>Дней просрочки</p>
                  </th>
                  {!isExtensionThreeImplementaition && <th scope="col">
                    <p>Дней льготного срока</p>
                  </th>}
                  <th scope="col">
                    <p>Сумма на выкуп</p>
                  </th>
                  <th scope="col">
                    <p>Телефон</p>
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {overdueContracts &&
                  overdueContracts.length !== 0 &&
                  overdueContracts.map((overdue) => {

                    let delayDays = '';
                    if (accessFeatures['deal.expired.total_to_pay_remind']) {
                      const days = isExtensionThreeImplementaition ? overdue.delayDays : overdue.graceDays;
                        if (overdue.totalToPay >= overdue.totalEstimatedValue && days > 30) {
                            delayDays = 'overdue-delayColorGreen';
                        } else {
                            delayDays = 'overdue-delayColorRed';
                        }
                      }

                    return (
                      <Fragment key={overdue.id}>
                        <tr>
                          <td>
                            <div className="table-cellcontent">
                              <Checkbox
                                id={overdue.id}
                                name={overdue.id}
                                onChange={handleContractCheck}
                                value={overdue.checked}
                              />
                              <p>
                                <Link
                                  className="table-link"
                                  to={`client/${overdue.clientId}/contracts/${overdue.id}`}>
                                  <span>{overdue.dealNumber || overdue.id}</span>
                                </Link>
                              </p>
                            </div>
                          </td>
                          <td>
                            <div className="table-celltrigger">
                              <p>{overdue.clientFullName && overdue.clientFullName}</p>
                            </div>
                          </td>
                          <td>
                            <p className={delayDays}>{returnEndStr(overdue.delayDays)}</p>
                          </td>
                          {!isExtensionThreeImplementaition && <td>
                            <p className={delayDays}>{returnEndStr(overdue.graceDays)}</p>
                          </td>}
                          <td>
                            <p>{overdue.totalToPay.toFixed(2)} руб.</p>
                          </td>
                          <td>
                            <p>
                              <a className="table-phone" href="tel:+375333516789">
                                <span>{overdue.clientPhone && overdue.clientPhone}</span>
                              </a>
                            </p>
                          </td>
                          <td
                            className={`overdueContentAll-table-col-arrow${overdue.isVisible ? '-up' : ''
                              }`}>
                            <Arrow onClick={() => changeVisible(overdue.id)} />
                          </td>
                        </tr>
                        <tr
                          className={`overdueContentAll-table-line${overdue.isVisible ? '-visible' : ''
                            }`}>
                          <OverdueDetails overdue={overdue} />
                        </tr>
                      </Fragment>
                    );
                  })}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <AlertModal
        isOpen={popup.isOpen}
        handleClose={closeAlertModal}
        header={popup.header}
        text={popup.text}
      />
      <ConfirmModal
        isOpen={state.isToTransfer}
        handleClose={closeConfirm}
        handleAction={addToTransfer}
        headerText="Вы хотите переместить на передачу / в гараж?"
      />
      <Pagination
        total={Math.ceil(total / state.pageRange)}
        current={state.currentPage}
        handlePageChange={handlePageChange}
      />
      <ToFormRegisterModal
        printedFormButton = {true}
        isOpen={state.isRegister || state.isTN}
        handleCloseModal={handleCloseModal}
        view={state.viewDocument}
        cashBoxInfo={cashBoxInfo}
        dealIds={state.dealIds}
        submitTransferDeals={submitTransferDeals}
        permissibleDate={state.permissibleDate}
      />
      <OverestimationModal
        isOpen={state.isOverestimation}
        handleCloseModal={handleCloseModal}
        data={selectedDeals}
        submitOverestimation={submitOverestimation}
        view={state.isOverestimation}
        isOverestimation={true}
        tab={'FOR_TRANSMISSION'}
      />
      <ToFormWithdrawalInventoryModal
        isOpen={state.isWithdrawal}
        handleCloseModal={handleCloseModal}
        view={state.viewDocument}
        cashBoxInfo={cashBoxInfo}
        dealIds={state.dealIds}
        submitTransferDeals={submitTransferDeals}
        permissibleDate={state.permissibleDate}
      />
    </>
  );
});

export default OverdueContentAll;
